import { styled } from '@clickcease/cc-client-components-lib'

export const PaidMarketingStyled = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
})

export const PaidMarketingSliderWrapper = styled('div', {
  color: '$primaryColor',
  fontSize: '$h3',
  display: 'flex',
  margin: '40px 0',

  '@bp1': {
    flexDirection: 'column',
    position: 'relative',
    width: '90%',
    margin: '60px 0',
    zIndex: 2,
  },
})

export const PaidMarketingSliderText = styled('div', {
  color: '$black',
  fontSize: '$h3',
  fontWeight: '$sb',
  marginRight: '$8',

  '@bp1': {
    fontWeight: '$b',
    fontSize: '$lg',
    marginBottom: '$4',
  },
})

export const PaidMarketingSelectWrapper = styled('div', {
  marginLeft: '63px',

  '@bp1': {
    position: 'absolute',
    top: '-$20',
    right: '-$3',
  },
})

export const PaidMarketingPlanWrapper = styled('div', {
  display: 'grid',
  justifyContent: 'space-between',
  gridTemplateColumns: 'repeat(3, 1fr)',
  gridColumnGap: '$16',

  variants: {
    bundle: {
      true: {
        gridColumnGap: '$10',
      },
    },
    crossSell: {
      true: {
        '> div': {
          marginTop: '60px',
          marginRight: '$8',

          '@laptop': {
            marginRight: '$4',
          },
        },
      },
    },
  },
})

export const MobileTextCss = { lineHeight: '20px' }

export const ToasterWrapper = styled('div', {
  width: '100%',
  display: 'flex',
  justifyContent: 'space-around',
  marginBottom: '$6',
  marginRight: '470px',
  '@bp1': {
    width: '74%',
    marginRight: 'unset',
  },
})
